import React from 'react';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { Typography, makeStyles } from '@material-ui/core';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import StepStatusTracking from '../OnboardingPage/Steps/StepStatusTracking';
import { useStyles as useOnboardingStyles } from '../OnboardingPage/utils/styles';

const useStyles = makeStyles({
  page: {
    minHeight: '100vh',
    background: '#f4f5f7',
  },
  orgBar: {
    position: 'sticky',
    top: 0,
    zIndex: 1300,
    backgroundColor: 'black',
    color: 'white',
    padding: '18px',
    borderLeft: '0.1px solid #535353',
    fontWeight: 700,
    fontSize: '30px',
  },
  hero: {
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(120deg, #1a1a1a 0%, #2b2b2b 60%, #383838 100%)',
    color: '#fff',
    padding: '28px 32px',
    borderBottom: '4px solid #FFCD11',
  },
  heroAccent: {
    position: 'absolute',
    top: -60,
    right: -40,
    width: 220,
    height: 220,
    borderRadius: '50%',
    background:
      'radial-gradient(circle, rgba(255,205,17,0.18) 0%, rgba(255,205,17,0) 70%)',
    pointerEvents: 'none',
  },
  heroRow: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  heroIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 52,
    height: 52,
    borderRadius: 14,
    background: 'rgba(255,205,17,0.15)',
    border: '1px solid rgba(255,205,17,0.4)',
    flexShrink: 0,
  },
  heroTitle: {
    fontWeight: 800,
    fontSize: 26,
    lineHeight: 1.1,
    letterSpacing: '0.01em',
  },
  heroSubtitle: {
    marginTop: 4,
    fontSize: 14,
    color: 'rgba(255,255,255,0.7)',
  },
  body: {
    padding: '24px 32px 40px',
  },
  card: {
    background: '#fff',
    borderRadius: 14,
    border: '1px solid #ececec',
    boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
    padding: 24,
    maxWidth: 1100,
    margin: '0 auto',
  },
});

export function TrackAdoptionRequestPage() {
  const classes = useStyles();
  const onboardingClasses = useOnboardingStyles();
  const orgName =
    useApi(configApiRef).getOptionalString('organization.name') ?? 'Service Catalog';

  return (
    <div className={classes.page}>
      <div className={classes.orgBar}>{orgName}</div>

      <div className={classes.hero}>
        <div className={classes.heroAccent} />
        <div className={classes.heroRow}>
          <span className={classes.heroIcon}>
            <TrackChangesIcon style={{ color: '#FFCD11', fontSize: 30 }} />
          </span>
          <div>
            <Typography className={classes.heroTitle}>
              Track Adoption Request
            </Typography>
            <Typography className={classes.heroSubtitle}>
              Monitor the status of your submitted onboarding requests in real time.
            </Typography>
          </div>
        </div>
      </div>

      <div className={classes.body}>
        <div className={classes.card}>
          <StepStatusTracking classes={onboardingClasses} />
        </div>
      </div>
    </div>
  );
}

export default TrackAdoptionRequestPage;
